// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import connect from '@h/connect-redux'
import { findEntities, findEntityBySysId } from '@r/contentful-selectors'
import Breadcrumbs from './breadcrumbs.connected'
import Billboard from '@uswitch/ev-components/lib/components/modules/billboard/billboard'

import {
  ContentfulModules,
  moduleEntity,
} from '@uswitch/ev-components/lib/components/helpers/modules'
import { RichText, EVEntry } from '@uswitch/ev-core/react'
import { useEntity } from '@h/use-entity'

const BillboardConnected = ({
  breadcrumbs,
  primaryContent,
  primarySlot,
  fullWidthSlot,
  image,
  showImageOnMobile,
  mobileImage,
}) => {
  const breadcrumbComponent = breadcrumbs && <Breadcrumbs entity={breadcrumbs} variant='light' />
  const primaryContentComponent = primaryContent && <RichText content={primaryContent} />
  const primarySlotComponent = primarySlot && <EVEntry {...moduleEntity(primarySlot)} />
  const fullWidthSlotComponent = fullWidthSlot && <ContentfulModules modules={fullWidthSlot} />
  const imageEntity = useEntity(image)
  const mobileImageEntity = useEntity(mobileImage)

  return (
    <Billboard
      breadcrumbs={breadcrumbComponent}
      primaryContent={primaryContentComponent}
      primarySlot={primarySlotComponent}
      fullWidthSlot={fullWidthSlotComponent}
      bgImage={imageEntity?.file?.url}
      showImageOnMobile={showImageOnMobile}
      mobileImage={mobileImageEntity?.file?.url}
    />
  )
}

export default connect(
  (
    state,
    {
      breadcrumbs,
      primaryContent,
      primarySlot,
      fullWidthSlot,
      image,
      showImageOnMobile,
      mobileImage,
    },
  ) => {
    const breadcrumbsEntity = breadcrumbs && findEntityBySysId(state, breadcrumbs.sys.id)
    const primarySlotEntity = primarySlot && findEntityBySysId(state, primarySlot.sys.id)
    const fullWidthSlotEntities = fullWidthSlot && findEntities(state, fullWidthSlot)

    return {
      primaryContent,
      primarySlot: primarySlotEntity,
      fullWidthSlot: fullWidthSlotEntities,
      breadcrumbs: breadcrumbsEntity,
      image,
      showImageOnMobile,
      mobileImage,
    }
  },
)(BillboardConnected)
